import React from 'react'
import { Button } from 'loyal-react'

const Unavailable = () => (
  <div className='card-button col-12 m-0 mt-1 p-0 mb-1'>
    <Button
      className='btn-featured btn-sm btn-block col-12'
      text='Produto indisponível'
      disabled='disabled'
    />
  </div>
)

export default Unavailable



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductAvailability/Unavailable.js